import { render, staticRenderFns } from "./SingleAutoSave.vue?vue&type=template&id=2aab08bf&scoped=true"
import script from "./SingleAutoSave.vue?vue&type=script&lang=js"
export * from "./SingleAutoSave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aab08bf",
  null
  
)

export default component.exports